import { useTranslation } from 'react-i18next';
import { isApiError } from '@shared/api';
import { Alert, AlertTitle, AlertDescription, Button } from '@shared/ui';
export function AiContentError({
  error,
  onRetry,
  loading = false,
}: {
  error: unknown;
  onRetry?: () => void;
  loading?: boolean;
}) {
  const { t } = useTranslation();
  const status = isApiError(error) ? error.status : undefined;
  const key =
    status === 401
      ? 'aiContent.read.signedOut'
      : status === 403
        ? 'aiContent.read.denied'
        : status === 404
          ? 'aiContent.errors.notFound'
          : 'aiContent.read.failed';
  const retryable =
    status === undefined || status === 0 || status === 408 || status === 429 || status >= 500;
  return (
    <Alert variant="destructive">
      <AlertTitle>{t(key)}</AlertTitle>
      {onRetry && retryable ? (
        <AlertDescription>
          <Button type="button" variant="outline" size="sm" loading={loading} onClick={onRetry}>
            {t('common.retry')}
          </Button>
        </AlertDescription>
      ) : null}
    </Alert>
  );
}
